import { render } from "./SmartcatAttachment.vue?vue&type=template&id=13fc21ad&scoped=true"
import script from "./SmartcatAttachment.vue?vue&type=script&lang=js"
export * from "./SmartcatAttachment.vue?vue&type=script&lang=js"

import "./SmartcatAttachment.vue?vue&type=style&index=0&id=13fc21ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fc21ad"]])

export default __exports__